import appconfig from '@/utils/appConfig';
import clsx from 'clsx';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
// removed

interface PropsWithChildren {
    canScrollPrev: boolean;
    canScrollNext: boolean;
    onPrev(): void;
    onNext(): void;
    children: React.ReactNode;
}

const CarouselControls = ({ children, ...props }: PropsWithChildren) => {
    return (
        <div className="flex bg-transparent pt-4 h-[460px] md:h-[500px] relative">
            <button
                onClick={() => {
                    if (props.canScrollPrev) {
                        props.onPrev();
                    }
                }}
                disabled={!props.canScrollPrev}
                className={clsx(
                    {
                        'text-white rounded-md opacity-50 bg-transparent': true,
                        'hover:opacity-100': props.canScrollPrev,
                        'text-xl sm:text-3xl': true,
                    },
                    'absolute',
                    'z-20',
                    'left-0',
                    'top-1/4',
                    'h-1/2'
                )}
            >
                <div className={appconfig.colors.coloredSectionText}>
                    <FaChevronLeft size={60} />
                </div>
            </button>
            {children}
            <button
                onClick={() => {
                    if (props.canScrollNext) {
                        props.onNext();
                    }
                }}
                disabled={!props.canScrollNext}
                className={clsx(
                    {
                        'text-white rounded-md opacity-50 bg-transparent': true,
                        'hover:opacity-100': props.canScrollNext,
                        'text-3xl': true,
                    },
                    'absolute',
                    'z-20',
                    'right-0',
                    'top-1/4',
                    'h-1/2'
                )}
            >
                <div className={appconfig.colors.coloredSectionText}>
                    <FaChevronRight size={60} />
                </div>
            </button>
        </div>
    );
};
export default CarouselControls;
